<script setup>
import HTitle from "~/components/seo/HTitle.vue"

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const blockContent = computed(() => props.data.content)
const haveVSpacing = computed(() => blockContent.value.vSpacing)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'my-6': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})
</script>

<template>
  <div v-if="blockContent" class="grid grid-cols-12 py-3" :class="containerClasses">
    <div class="col-span-12 px-4">
      <HTitle v-if="blockContent.title" :type="blockContent.titleH" class="text-center mt-4 mx-4 lg:mx-0 !text-red-800">
        {{
          blockContent.title
        }}
      </HTitle>
      <div class="text-justify px-4 lg:px-8 text-description" v-html="blockContent.description"></div>
    </div>
  </div>
</template>
